import { useEffect, useRef, useState } from "react";
import { ChevronDown } from "lucide-react";
import {
  FilterSelectWrapper,
  FilterSelectTrigger,
  FilterSelectMenu,
  FilterSelectOption,
} from "./styles.tableWithFilters";

/** Single-select dropdown for filter cards. options: [{ value, label }] */
export default function FilterSelect({ value, options, onChange, placeholder = "Select" }) {
  const [isOpen, setIsOpen] = useState(false);
  const wrapperRef = useRef(null);
  const selected = options.find((option) => option.value === value);

  useEffect(() => {
    if (!isOpen) return undefined;
    const handleClickOutside = (event) => {
      if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [isOpen]);

  return (
    <FilterSelectWrapper ref={wrapperRef}>
      <FilterSelectTrigger type="button" aria-haspopup="listbox" aria-expanded={isOpen} onClick={() => setIsOpen((open) => !open)}>
        <span>{selected ? selected.label : placeholder}</span>
        <ChevronDown size={16} />
      </FilterSelectTrigger>
      {isOpen && (
        <FilterSelectMenu role="listbox">
          {options.map((option) => (
            <FilterSelectOption
              key={option.value}
              role="option"
              aria-selected={option.value === value}
              $selected={option.value === value}
              onClick={() => {
                onChange(option.value);
                setIsOpen(false);
              }}
            >
              {option.label}
            </FilterSelectOption>
          ))}
        </FilterSelectMenu>
      )}
    </FilterSelectWrapper>
  );
}
